export const mtnServiceIdMap = new Map
const ServiceIdsMtn = {
    free: "mzansi-rhythm-free",
    vipDaily: "mzansi-rhythm-daily",
    vipWeekly: "mzansi-rhythm-weekly",
    vipMonthly: "mzansi-rhythm-monthly"
}
export const setServiceIds = () => {
    mtnServiceIdMap.set(ServiceIdsMtn.free, 1);
    mtnServiceIdMap.set(ServiceIdsMtn.vipDaily, 2);
    mtnServiceIdMap.set(ServiceIdsMtn.vipWeekly, 2);
    mtnServiceIdMap.set(ServiceIdsMtn.vipMonthly, 2);
}

